import { select, call } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { scrollToTop } from 'redux/saga/helpers';
import { userNeedsPhoneVerification } from 'features/PhoneVerification/PhoneVerification.saga';

// redirects to the signup URL for this item if you are not logged in
// redirects to the purchase URL for this item if you are already verified
export function* phoneVerificationOnEnterSaga(client, nextState, replaceState) {
  const loggedIn = yield select(isLoggedIn);

  yield call(scrollToTop);

  if (!loggedIn) {
    yield call(replaceState, {
      ...nextState.location,
      pathname: nextState.location.pathname.replace(/^\/verify-phone/, '/signup'),
    });
    return;
  }

  const needsVerification = yield call(userNeedsPhoneVerification, client);

  if (!needsVerification) {
    yield call(replaceState, {
      ...nextState.location,
      pathname: nextState.location.pathname.replace(/^\/verify-phone/, '/purchase'),
    });
  }
}
